'use client'

import { PRODUCT_INFO_SERVICE_URL } from 'product/constants/constants'
import type { Product } from 'product/types'
import { multipleUrlsFetcher } from 'services/rest/multipleUrlsFetcher'
import useSWRImmutable from 'swr/immutable'
import type { PageParams } from 'types/pageParams'
import { env } from 'utils/envManager'

interface UseProductsInfoProps {
	country: PageParams['country']
	language: PageParams['language']
	productIds: string[] | undefined
	enabled?: boolean
}

export const useProductsInfo = ({
	language,
	country,
	productIds,
	enabled = true,
}: UseProductsInfoProps) => {
	const searchParams = new URLSearchParams({
		countryIso: country,
		channelId: env.NEXT_PUBLIC_CHANNEL,
		languageIso: language,
	})

	const urls = productIds?.map((productId) => {
		searchParams.set('productId', productId)

		const url = new URL(
			PRODUCT_INFO_SERVICE_URL,
			env.NEXT_PUBLIC_ORCHESTRATOR_DOMAIN
		)
		url.search = searchParams.toString()

		return url.href
	})

	const { data, mutate } = useSWRImmutable(
		enabled && productIds ? urls : null,
		multipleUrlsFetcher<Product>
	)

	const products =
		data && productIds
			? Object.values(data).map((product, index) => ({
					...product,
					id: productIds[index],
				}))
			: []

	return {
		data: products,
		mutate,
	}
}
